import React from 'react'

export default class StatusBar extends React.Component {
    constructor(props) {
        super(props);
        
    }

    componentDidMount() {
        // #  Enable tooltips
		jQuery(jQuery(".tooltip_custom")).hover(function() {
				jQuery(this).find('[data-toggle="tooltip"]').tooltip('show');
			}, function() {
				jQuery(this).find('[data-toggle="tooltip"]').tooltip('hide');
			}
		);
    }
    

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="notification_on_screen">
                <a href="#" class={"tooltip_custom editmodeNotification " + this.props.toggles.editMode}><i class="fa fa-exclamation-triangle"><span data-toggle="tooltip" data-original-title={"Edit mode is " + this.props.toggles.editMode} title="" class="editmode_tooltip"></span></i></a>
                <a href="#" class={"tooltip_custom freeroam " + this.props.toggles.freeRoam}><i class="fa fa-arrows"><span data-toggle="tooltip" data-placement="bottom" data-original-title={"Free Roam is " + this.props.toggles.freeRoam} title="" class="freeroam_tooltip"></span></i></a>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Graphics/Editor/StatusBar.jsx